'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {RegisterCtrl} from "./registerctrl.js";
EwSiteApp.controller('RegisterCtrl', ["$scope", "$http", "$filter", "$mdDialog", "jsDataService", "notify", "pageProgress", RegisterCtrl]);

import {ActivateRegistrationCtrl} from "./activateregistrationctrl.js";
EwSiteApp.controller('ActivateRegistrationCtrl', ["$scope", "jsDataService", "notify", "pageProgress", ActivateRegistrationCtrl]);

import {MyProfileCtrl} from "./myprofilectrl.js";
EwSiteApp.controller('MyProfileCtrl', ["$scope", "jsDataService", "notify", "pageProgress", "$mdDialog", MyProfileCtrl]);

EwSiteApp.directive('tocpreview', ['$mdDialog', function($mdDialog){
	return {
		restrict: 'C',
		link: function(scope, element, attrs){
			element.on('click', function (ev) {
				ev.stopPropagation();
				$mdDialog.show({
					controller: ["$scope", "$mdDialog", function($scope, $mdDialog){
						$scope.accept = function(){
							$mdDialog.hide({accept: true});
						};
						$scope.close = function() {
							$mdDialog.cancel();
						};
					}],
					templateUrl: 'register/termsconditions.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose:true,
					fullscreen: true,
				}).then(function(results){
					if(results.accept){
						scope.$parent.$parent.ctrl.user.agreement = true;
					}
				}, function(){});
			});
		}
	};
}]);
EwSiteApp.directive('passwordPolicyValidator', ['jsDataService', function(jsDataService) {
	return {
		require : 'ngModel',
		link : function(scope, element, attrs, ngModel) {
			const cfg = jsDataService.get('cfg.passwordPolicy', {});
			ngModel.$parsers.push(function(value) {
				if(!value || value.length == 0) return;
				if(cfg.includeNumber){
					ngModel.$setValidity('digit', /[0-9]/.test(value));
				}
				if(cfg.includeUpercase){
					ngModel.$setValidity('case', /[A-Z]/.test(value) && /[a-z]/.test(value)); 
				}
				if(cfg.includeSymbol){
					ngModel.$setValidity('special', /[^a-z0-9 ]/i.test(value));
				}
				return value;
			});
		}
	  };
}]);
EwSiteApp.directive('passwordEqual', function() {
	return {
		require : 'ngModel',
		scope: {
			compareModel: '@'
		},
		link : function(scope, element, attrs, ngModel) {
			ngModel.$parsers.push(function(value) {
				if(!value || value.length == 0) return;
				ngModel.$setValidity('equal', (value === scope.compareModel));
				return value;
			});
		}
	};
});
